import { getRequiredFn } from 'utils/reduxForm/validations';
import { getRequiredFn as zeroNotRequired } from 'modules/Taps/components/NDFL3/utils/validations';
import bigJs from 'big.js/big';

export const isRequiredFn = zeroNotRequired();
export const reduxRequired = getRequiredFn();

export const numberFieldRestrict9Fn = ({ value }) => {
  if (!value) {
    return true;
  }
  return bigJs(value).lte('999999999');
};
export const numberFieldRestrict10Fn = ({ value }) => {
  if (!value) {
    return true;
  }
  return bigJs(value).lte('9999999999');
};
export const numberFieldRestrict12Fn = ({ value }) => {
  if (!value) {
    return true;
  }
  return bigJs(value).lte('999999999999');
};

export const numberFieldRestrict13Fn = ({ value }) => {
  if (!value) {
    return true;
  }
  return bigJs(value).lte('9999999999999');
};

export const numberFieldRestrict12_2Fn = ({ value }) => {
  if (!value) {
    return true;
  }
  return bigJs(value).lte('999999999999.99');
};

export const numberFieldRestrict7Fn = ({ value }) => {
  if (!value) {
    return true;
  }
  return bigJs(value).lte('9999999');
};

export const numberFieldRestrict14_4Fn = ({ value }) => {
  if (!value) {
    return true;
  }
  return bigJs(value).lte('99999999999999.9999');
};

export const numberFieldRestrict14_2Fn = ({ value }) => {
  if (!value) {
    return true;
  }
  return bigJs(value).lte('99999999999999.99');
};

export const numberFieldRestrict14_2NoMore400kFn = ({ value }) => {
  if (!value) {
    return true;
  }
  return bigJs(value).lte('400000.00');
};

export const numberFieldRestrict13_2Fn = ({ value }) => {
  if (!value) {
    return true;
  }
  return bigJs(value).lte('9999999999999.99');
};

export const numberFieldRestrict10_2Fn = ({ value }) => {
  if (!value) {
    return true;
  }
  return bigJs(value).lte('9999999999.99');
};

export const numberFieldRestrict8_2Fn = ({ value }) => {
  if (!value) {
    return true;
  }
  return bigJs(value).lte('99999999.99');
};

export const numberFieldRestrict19_6Fn = ({ value }) => {
  if (!value) {
    return true;
  }
  return bigJs(value).lte('9999999999999999999.999999');
};

export const numberFieldRestrict17_2Fn = ({ value }) => {
  if (!value) {
    return true;
  }
  return bigJs(value).lte('99999999999999999.99');
};
export const numberFieldRestrict15_2Fn = ({ value }) => {
  if (!value) {
    return true;
  }
  return bigJs(value).lte('999999999999999.99');
};
export const numberFieldRestrict3_15Fn = ({ value }) => {
  if (!value) {
    return true;
  }
  return bigJs(value).lte('999.999999999999999');
};

export const numberFieldRestrict2Fn = ({ value }) => {
  if (!value) {
    return true;
  }
  return bigJs(value).lte('99');
};
